// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/external_source.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file studyo/today/planners/v1/resources/external_source.proto.
 */
export const file_studyo_today_planners_v1_resources_external_source = /*@__PURE__*/
  fileDesc("CjhzdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL2V4dGVybmFsX3NvdXJjZS5wcm90bxIic3R1ZHlvLnRvZGF5LnBsYW5uZXJzLnYxLnJlc291cmNlcyKxAQoORXh0ZXJuYWxTb3VyY2USEwoLc291cmNlX25hbWUYASABKAkSEwoLZXh0ZXJuYWxfaWQYAiABKAkSCwoDdXJsGAMgASgJEjIKDmxhc3Rfc3luY190aW1lGAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBI0ChBsYXN0X3VwZGF0ZV90aW1lGAUgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEIqqgInU3R1ZHlvLlRvZGF5LlBsYW5uZXJzLkdycGMuVjEuUmVzb3VyY2VzYgZwcm90bzM", [file_google_protobuf_timestamp]);

/**
 * Describes the message studyo.today.planners.v1.resources.ExternalSource.
 * Use `create(ExternalSourceSchema)` to create a new message.
 */
export const ExternalSourceSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_resources_external_source, 0);

